// import { keywords } from '@/configs/translates.config';

export default {
	'add-new-qa': 'Add new QA',
	qa: 'QA',
	'the-qa': 'the QA?'
}